/**
 * List of known extension keys for the bucket
 */ export var BucketExtensionKeys = /*#__PURE__*/ function(BucketExtensionKeys) {
    /** The extension with legacy data for legacy basic entities */ BucketExtensionKeys["legacyData"] = "LegacyData";
    /** The extension key for the bucket color (hex color string e.g. "#d8cce7"), stored as a string */ BucketExtensionKeys["bucketColor"] = "bucketColor";
    return BucketExtensionKeys;
}({});
